module.exports = __webpack_public_path__ + "static/media/flying-gurnard.7cd20d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/flying-gurnard.png
// module id = 311
// module chunks = 0